function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/Upload/uploadFile.vue';
import * as dangaoActApi from '@/api/dangaoActApi';
import throttle from '@/utils/throttle';
export default {
  components: {
    UploadFile: UploadFile
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      addresData: [],
      ruleForm: {},
      brandOption: []
    };
  },
  mounted: function mounted() {
    this.getCityList();
    this.searchBrand('');
  },
  methods: {
    throttle: throttle,
    openInit: function openInit() {
      this.visible = true;
    },
    handerSubmit: function handerSubmit(form) {
      var _this = this;
      var _ref = this.ruleForm || {},
        brandId = _ref.brandId,
        type = _ref.type,
        _ref$areaList = _ref.areaList,
        areaList = _ref$areaList === void 0 ? [] : _ref$areaList;
      var _ref2 = areaList || [],
        _ref3 = _slicedToArray(_ref2, 2),
        pcode = _ref3[0],
        cityCode = _ref3[1];
      this.loading = true;
      dangaoActApi.syncCakeProduct({
        brandId: brandId,
        cityCode: cityCode,
        type: type
      }).then(function (res) {
        _this.$message.success('操作成功！');
        _this.loading = false;
        _this.closeEdit();
        _this.$emit('doRefresh');
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getCityList: function getCityList() {
      var _this2 = this;
      this.addresData = [];
      dangaoActApi.getShopFslAddress().then(function (res) {
        _this2.addresData = res || [];
      });
    },
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword, 2).then(function (res) {
        _this3.brandOption = res && res.length && res.map(function (item) {
          var _ref4 = item || {},
            brandId = _ref4.brandId,
            brandName = _ref4.brandName,
            source = _ref4.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchBrand(data);
      }, 300)();
    }
  }
};